export default () => 'Contact – Conjugr8'
